export default __webpack_public_path__ + "static/media/orange_2.png";